import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class AppUpdateService {

  constructor(private readonly updates: SwUpdate, private toastService : ToastService) {
    console.log('AppUpdateService Check');

    this.updates.versionUpdates.subscribe((evt) => {
      console.log('versionUpdates');
      console.log(evt);

      switch (evt.type) {
        case 'VERSION_READY':
          this.showAppUpdateAlert();
          break;
      }
    });

    this.updates.unrecoverable.subscribe(() => {
      console.log('unrecoverable');
    });
  }

  init() {
    console.log('checkForUpdate');
    if (this.updates.isEnabled) {
      this.updates.checkForUpdate().then((res) => {
        console.log('checkForUpdate', res);
      }).catch((err) => {
        console.log('checkForUpdate', err);
      });
    } else {
      console.log('checkForUpdate', 'disabled');
    }
  }

  forceUpdate() {
    console.log('activateUpdate');

    this.updates.activateUpdate().then((res) => {
      console.log('activateUpdate', res);
      document.location.reload();
    }).catch((err) => {
      console.log('activateUpdate', err);
    });
  }

  showAppUpdateAlert() {
    this.toastService.warning('UPDATE_SERVICE_WORKER');

    // eslint-disable-next-line angular/timeout-service
    setTimeout(() => {
      this.doAppUpdate();
    }, 2000);
  }

  doAppUpdate() {
    this.updates.activateUpdate().then(() => {
      this.toastService.toastSuccess('UPDATE_SERVICE_WORKER_DONE');
      // eslint-disable-next-line angular/timeout-service
      setTimeout(() => {
        document.location.reload();
      }, 2000);
    });
  }
}
